export function Vorlaeufig({ titel }: { titel: string }) {
  return (
    <main className="seite">
      <h1>{titel}</h1>
    </main>
  );
}
